import { useState } from "react";
import { Link } from "react-router-dom";
import { getFeatured } from "@/lib/catalog";
import TitleGrid from "@/components/feature/TitleGrid";

type TabKey = "movie" | "tv";

const TABS: { key: TabKey; label: string; hint: string }[] = [
  { key: "movie", label: "最新电影", hint: "按热度推荐的欧美电影" },
  { key: "tv", label: "最新剧集", hint: "正在热播的欧美剧集" },
];

export default function FeaturedSection() {
  const [tab, setTab] = useState<TabKey>("movie");
  const items = getFeatured(tab, 8);
  const active = TABS.find((t) => t.key === tab) ?? TABS[0];

  return (
    <section className="mx-auto w-full max-w-[1400px] px-4 pt-14 md:px-8 md:pt-20">
      <div className="mb-5 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div className="flex items-center gap-3">
          <span className="block h-5 w-1 rounded-full bg-accent-500" />
          <div>
            <h2 className="font-heading text-lg font-bold text-foreground-50 md:text-xl">
              精选推荐
            </h2>
            <p className="mt-1 text-xs text-foreground-400 md:text-sm">{active.hint}</p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1 rounded-full border border-background-700 bg-background-900 p-1">
            {TABS.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setTab(t.key)}
                className={`rounded-full px-4 py-1.5 text-xs transition-colors whitespace-nowrap cursor-pointer md:text-sm ${
                  tab === t.key
                    ? "bg-primary-500 font-medium text-foreground-50"
                    : "text-foreground-300 hover:text-foreground-50"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
          <Link
            to={`/category?type=${tab}`}
            className="hidden items-center gap-1 text-xs text-secondary-300 transition-colors hover:text-accent-400 sm:inline-flex md:text-sm cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-s-line text-base" />
          </Link>
        </div>
      </div>

      <TitleGrid items={items} className="lg:grid-cols-4" />

      <div className="mt-5 sm:hidden">
        <Link
          to={`/category?type=${tab}`}
          className="inline-flex items-center gap-1 text-sm text-secondary-300 cursor-pointer"
        >
          查看全部
          <i className="ri-arrow-right-s-line text-base" />
        </Link>
      </div>
    </section>
  );
}